import { fetcher } from '@commenda/utils';

export const assignCAFirm = async (
  {
    corporationId,
    caFirmId,
    complianceStartDate,
  }: { corporationId: number; caFirmId: string; complianceStartDate: string },
  nextAuthtoken: string
): Promise<boolean> => {
  const response = await fetcher(
    'caFirm/assignCorporation',
    {
      body: { corporationId, caFirmId, complianceStartDate },
      method: 'POST',
    },
    nextAuthtoken
  );

  if (!response.ok) return false;
  return true;
};
